<template>
  <v-navigation-drawer
    id="nav-drawer"
    v-model="drawer"
    app
  >
    <v-sheet class="d-flex justify-start align-center" height="76" id="nav-drawer-header">
      <div id="menu-icon" style="cursor: pointer">
        <v-img @click="drawer = !drawer" class="mr-2 ml-4" width="24" src="/icons/ic-menu-item.svg" />
      </div>
      <div id="top-icon" @click="$router.push('/')" style="cursor: pointer">
        <img src='/logo_white.png' width="100px"  alt="logo"/>
      </div>
    </v-sheet>
    <v-divider></v-divider>

    <v-list nav :density="denseItems" v-if="!isCoursePage" >
      <v-list-item class="pl-3 align-center pr-0"
                   v-if="can('view', 'Program') && program">
        <template v-slot:prepend>
          <v-avatar rounded color="white" :size="$vuetify.display.height < 950 ? 26 : 30">
            <span data-hj-suppress v-if="program.title">
              {{ program.title.charAt(0)+program.title.charAt(1) }}
            </span>
          </v-avatar>
        </template>
        <v-list-item-title class="menu-title no-truncate" data-hj-suppress>
          {{ program.title }}
        </v-list-item-title>
        <template v-slot:append>
          <v-menu
            bottom
            offset-y
          >
            <template v-slot:activator="{ props }">
              <v-btn
                color="white"
                size="x-small"
                variant="text"
                v-bind="props"
                icon
              >
                <v-icon size="large" class="mdi-rotate-90">mdi-code-tags</v-icon>
              </v-btn>
            </template>

            <v-list style="overflow-y: auto"
                    @change="changeProgram" v-model="selectedProgram" max-height="200">
              <v-list-subheader>{{ $t('common.navigation.my_programs') }}</v-list-subheader>
              <v-list-item
                active-class="text-selected-program"
                @click="changeProgram(item)"
                v-for="(item, i) in programs"
                :key="i"
                :active="item === program"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-list-item>

   <v-list-item
        class="pl-8"
        active-class="list-item-selected"
        :active="$route.name === 'home'"
        @click="$router.push({ name: 'home' })">
        <template v-slot:prepend >
          <v-img src="/icons/home.svg" width="24" class="mr-2" />       
        </template>
        <v-list-item-title class="menu-title">
          {{ $t('common.navigation.home') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        class="pl-8"
        active-class="list-item-selected"
        :active="$route.name === 'learn'"
        @click="$router.push({ name: 'learn' })">
        <template v-slot:prepend >
          <v-img src="/icons/dashboard.svg" width="24" class="mr-2" />
        </template>
        <v-list-item-title class="menu-title">
          {{ $t('common.navigation.dashboard') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="program && can('view', 'Program')"
        class="pl-8"
        active-class="list-item-selected"
        :active="$route.name === 'program-recordings'"
        @click="$router.push({ name: 'program-recordings' })">
        <template v-slot:prepend >
          <v-img src="/icons/video-recordings.svg" width="24" class="mr-2"/>
        </template>
        <v-list-item-title class="menu-title">
          {{ $t('common.navigation.video_recordings') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-else
                   class="pl-8"
                   active-class="list-item-selected"
                   :active="$route.name === 'my-recordings'"
                   @click="$router.push({ name: 'my-recordings' })">
        <template v-slot:prepend >
          <v-img src="/icons/video-recordings.svg" width="24" class="mr-2"/>
        </template>
        <v-list-item-title class="menu-title">
          {{ $t('common.navigation.video_recordings') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        class="pl-8"
        v-if="can('view', 'CoachingSessions')"
        active-class="list-item-selected"
        :active="$route.name === 'coaching-sessions'"
        @click="$router.push({ name: 'coaching-sessions' })">
        <template v-slot:prepend>
          <v-img src="/icons/coaching-sessions.svg" width="24" class="mr-2"/>
        </template>
        <v-list-item-title class="menu-title">
          {{ $t('common.navigation.coaching_sessions') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        class="pl-8"
        v-if="can('view', 'RolePlayPractice') && hasRoleplayMode"
        active-class="list-item-selected"
        :active="roleplayRoutes.includes($route.name)"
        @click="$router.push({ name: 'roleplay', params: { program_slug: program ? program.slug : null } })">
        <template v-slot:prepend>
          <v-img src="/icons/ic-solar_user-id-white.svg" width="24" class="mr-2"/>
        </template>
        <v-list-item-title class="menu-title">
          {{ $t('common.navigation.roleplay') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="program && can('view', 'ProgramMembers')"
        class="pl-8"
        active-class="list-item-selected"
        :active="$route.name === 'program-members'"
        @click="$router.push({ name: 'program-members'})">
        <template v-slot:prepend>
          <v-img src="/icons/ic-user.svg" width="24" class="mr-2"/>
        </template>
        <v-list-item-title class="menu-title">
          {{ $t('common.navigation.program_members') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-group>
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props">
            <template v-slot:prepend>
              <v-img src="/icons/activities.svg" width="24" class="mr-2 ml-6"/>
            </template>
            <v-list-item-title class="menu-title">
              {{ $t('common.navigation.materials') }}
            </v-list-item-title>
            <template v-slot:append>
              <v-icon color="white">mdi-menu-down</v-icon>
            </template>
          </v-list-item>
        </template>

        <v-list-item
          :active="$route.name === 'course-materials'"
          active-class="list-item-selected"
          v-if="can('view', 'Course') || can('view', 'PartialCourse')"
          @click="$router.push({ name: 'course-materials' })">
          <v-list-item-title class="menu-title">
            <v-icon color="white" class="mr-2">mdi-circle-medium</v-icon>
            {{ $t('common.navigation.materials_courses') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :active="$route.name === 'exercises'"
          active-class="list-item-selected"
          @click="$router.push({ name: 'exercises' })">
          <v-list-item-title class="menu-title">
            <v-icon color="white" class="mr-2">mdi-circle-medium</v-icon>
            {{ $t('common.navigation.materials_exercises') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="can('view', 'Document')"
          :active="$route.name === 'documents-materials'"
          active-class="list-item-selected"
          @click="$router.push({ name: 'documents-materials'})">
          <v-list-item-title class="menu-title">
            <v-icon color="white" class="mr-2">mdi-circle-medium</v-icon>
            {{ $t('common.navigation.materials_docs') }}
          </v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>

    <div v-if="isCoursePage && can('view', 'Course')">
      <v-list nav>
        <v-list-item key="title" @click="navigateTo(navTitle)" v-if="navTitle">
          <v-list-item-title class="course-title no-truncate">
            {{ navTitle.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-group
          class="course-chapter"
          v-for="item in courseItems"
          :key="item.id"
        >
          <template v-slot:activator="{ props, isOpen }" >
            <v-list-item
              v-bind="props"
              :active="item.id === $route.params.chapter_id && isOpen && !$route.params.section_id"
              @click="navigateTo(item);"
              active-class="list-item-selected"
              class="menu-title"
            >
              <template v-slot:prepend>
                <v-icon size="small" color="white">
                  {{ item.completed ? 'mdi-check-bold' : 'mdi-radiobox-blank' }}
                </v-icon>
              </template>

              <v-list-item-title class="menu-title no-truncate">
                <span :class="{ disabled: item.permission && !can(item.permission[0], item.permission[1]) }">
                  {{ item.name }}
                </span>

                <v-icon
                  class="float-right"
                  color="white"
                  size="small"
                  v-if="item.permission && !can(item.permission[0], item.permission[1])"
                >
                  mdi-help-circle
                </v-icon>
              </v-list-item-title>

              <template v-slot:append>
                <v-icon color="white" v-if="item.children.length">mdi-menu-down</v-icon>
              </template>
            </v-list-item>
          </template>

          <v-list-item
            class="course-section menu-title"
            v-for="subItem in item.children"
            v-bind:key="subItem.id"
            @click.stop="navigateTo(subItem)"
            active-class="list-item-selected"
            :active="$route.params.section_id === subItem.id"
          >
            <template v-slot:prepend>
              <v-icon size="x-small" color="white">
                {{ subItem.completed ? 'mdi-check-bold' : 'mdi-radiobox-blank' }}
              </v-icon>
            </template>
            <v-list-item-title class="menu-title no-truncate">
              {{ subItem.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>

    <div v-if="isCoursePage && can('view', 'PartialCourse')">
      <v-list class="pt-0" nav>
        <v-list-item class="pl-2" key="title" @click="navigateTo(navTitle)" v-if="navTitle">
          <v-list-item-title class="course-title no-truncate">
            {{ navTitle.title }}
          </v-list-item-title>
        </v-list-item>

        <v-list-group
          class="course-chapter"
          v-for="item in courseItems.slice(0, 3)"
          :key="item.id"
        >
          <template v-slot:activator="{ props, isOpen }" >
            <v-list-item
              v-bind="props"
              :active="item.id === $route.params.chapter_id && isOpen && !$route.params.section_id"
              @click="navigateTo(item);"
              active-class="list-item-selected"
              class="menu-title"
            >
              <template v-slot:prepend>
                <v-icon size="small" color="white">
                  {{ item.completed ? 'mdi-check-bold' : 'mdi-radiobox-blank' }}
                </v-icon>
              </template>

              <v-list-item-title class="menu-title no-truncate">
                <span :class="{ disabled: item.permission && !can(item.permission[0], item.permission[1]) }">
                  {{ item.name }}
                </span>

                <v-icon
                  class="float-right"
                  color="white"
                  size="small"
                  v-if="item.permission && !can(item.permission[0], item.permission[1])"
                >
                  mdi-help-circle
                </v-icon>
              </v-list-item-title>

              <template v-slot:append>
                <v-icon color="white" v-if="item.children.length">mdi-menu-down</v-icon>
              </template>
            </v-list-item>
          </template>

          <v-list-item
            class="course-section menu-title"
            v-for="subItem in item.children.slice(0, 3)"
            v-bind:key="subItem.id"
            @click.stop="navigateTo(subItem)"
            active-class="list-item-selected"
            :active="$route.params.section_id === subItem.id"
          >
            <template v-slot:prepend>
              <v-icon size="x-small" color="white">
                {{ subItem.completed ? 'mdi-check-bold' : 'mdi-radiobox-blank' }}
              </v-icon>
            </template>
            <v-list-item-title class="menu-title no-truncate">
              {{ subItem.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <upgrade-card top="400" >
        <v-list nav disabled>
          <v-list-group
            disabled
            class="course-chapter"
            v-for="item in courseItems.slice(3)"
            :key="item.id"
          >
            <template v-slot:activator="{ props, isOpen }" >
              <v-list-item
                v-bind="props"
                :active="item.id === $route.params.chapter_id && isOpen && !$route.params.section_id"
                @click="navigateTo(item);"
                active-class="list-item-selected"
                class="menu-title"
              >
                <template v-slot:prepend>
                  <v-icon size="small" color="white">
                    {{ item.completed ? 'mdi-check-bold' : 'mdi-radiobox-blank' }}
                  </v-icon>
                </template>

                <v-list-item-title class="menu-title no-truncate">
                <span :class="{ disabled: item.permission && !can(item.permission[0], item.permission[1]) }">
                  {{ item.name }}
                </span>

                  <v-icon
                    class="float-right"
                    color="white"
                    size="small"
                    v-if="item.permission && !can(item.permission[0], item.permission[1])"
                  >
                    mdi-help-circle
                  </v-icon>
                </v-list-item-title>

                <template v-slot:append>
                  <v-icon color="white" v-if="item.children.length">mdi-menu-down</v-icon>
                </template>
              </v-list-item>
            </template>

            <v-list-item
              class="course-section menu-title"
              v-for="subItem in item.children.slice(3)"
              v-bind:key="subItem.id"
              @click.stop="navigateTo(subItem)"
              active-class="list-item-selected"
              :active="$route.params.section_id === subItem.id"
            >
              <template v-slot:prepend>
                <v-icon size="x-small" color="white">
                  {{ subItem.completed ? 'mdi-check-bold' : 'mdi-radiobox-blank' }}
                </v-icon>
              </template>
              <v-list-item-title class="menu-title no-truncate">
                {{ subItem.name }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
      </upgrade-card>
    </div>

    <template v-slot:append>
      <v-list nav :density="denseItems" v-if="!isCoursePage">
        <v-divider class="mb-2"></v-divider>
        <v-list-item
          class="pl-8"
          active-class="list-item-selected"
          :active="$route.name === 'program-details'"
          v-if="program && can('view', 'Program')"
          @click="$router.push({
          name: 'program-details',
          params: { program_slug: program.slug },
        })"
        >
          <template v-slot:prepend>
            <v-img src="/icons/program-details.svg" width="24" class="mr-2"/>
          </template>
          <v-list-item-title class="menu-title">
            {{ $t('common.navigation.program_details') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="can('view', 'Faq')"
                     class="pl-8"
                     :active="$route.name === 'faq'"
                     active-class="list-item-selected"
                     @click="$router.push({name: 'faq'})">
          <template v-slot:prepend >
            <v-img src="/icons/faq.svg" width="24" class="mr-2"/>
          </template>
          <v-list-item-title class="menu-title">
            {{ $t('common.navigation.faq') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          class="pl-8"
          active-class="list-item-selected"
          target="_blank"
          href="mailto:rhetorich@myspeaker.fi">
          <template v-slot:prepend class="mr-2">
            <v-img src="/icons/contact-us.svg" width="24" class="mr-2" />
          </template>
          <v-list-item-title class="menu-title">
            {{ $t('common.navigation.contact_us') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :class="breakpointMobile ? 'pl-8 mb-16': 'pl-8'"
          active-class="list-item-selected"
          @click="showSignoutDialog=true">
          <template v-slot:prepend>
            <v-img src="/icons/logout.svg" width="24" class="mr-2"/>
          </template>
          <v-list-item-title class="menu-title">
            {{ $t('common.navigation.logout') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>

    <signout-dialog :show="showSignoutDialog" @close="showSignoutDialog=false"/>
  </v-navigation-drawer>
</template>
<script>
import permissions from '@/mixins/permissions';
import SignoutDialog from '@/components/dialog/SignoutDialog.vue';
import UpgradeCard from '@/components/UpgradeCard.vue';
import { hasAnyRoleplayMode } from '@/lib/roleplayModes';

export default {
  name: 'Navigation',
  components: { UpgradeCard, SignoutDialog },
  props: [],
  mixins: [permissions],
  data() {
    return {
      showSignoutDialog: false,
    };
  },
  computed: {
    selectedProgram() {
      return this.$store.getters['programs/selectedProgram'];
    },
    /*
     * The roleplay section spans several routes since the chooser took over `roleplay` and the
     * scenario grid moved to `roleplay-guided`. Matching only the landing route would drop the
     * highlight the moment the student picks a mode.
     */
    roleplayRoutes() {
      return [
        'roleplay',
        'roleplay-guided',
        'roleplay-quick',
        'roleplay-quick-confirm',
        'roleplay-scenarios',
        'roleplay-session',
        'roleplay-session-report',
      ];
    },
    isCoursePage() {
      return [
        'courses',
        'courses/section',
        'courses/chapter',
        'courses/admin',
        'courses/admin/section',
        'courses/admin/chapter',
      ].includes(this.$route.name);
    },
    breakpointMobile() {
      return this.$vuetify.display.mobile;
    },
    course() {
      return this.$store.getters['courses/selectedCourse'];
    },
    program() {
      return this.$store.getters['programs/selectedProgram'];
    },
    hasRoleplayMode() {
      return hasAnyRoleplayMode(this.program);
    },
    programs() {
      return this.$store.getters['programs/allPrograms'];
    },
    currentUserProgress() {
      return this.$store.getters['users/currentUserProgress'];
    },
    drawer: {
      get() {
        return this.$store.getters['userInterface/getDrawer'];
      },
      set(value) {
        if (this.isCoursePage
          && !(this.can('view', 'Course') || this.can('view', 'PartialCourse'))) {
          return this.$store.dispatch('userInterface/setDrawer', false);
        }

        return this.$store.dispatch('userInterface/setDrawer', value);
      },
    },
    courseItems() {
      if (!this.course || !this.course.chapters) return [];

      const userProgress = this.$store.getters['users/currentUserProgress'];
      const courseProgress = userProgress.courses.find(c => c.slug === this.course.slug);

      return this.course.chapters
        .filter((chapter) => {
          return chapter.status === 'Published' || this.userRole === 'Administrator';
        })
        .map((chapter) => {
          let chapterCompleted = chapter.sections.filter((section) => {
            return section.status === 'Published' || this.userRole === 'Administrator';
          }).reduce(
            (acc, item) => acc && courseProgress
              && courseProgress.completedItems.includes(item._id),
            true,
          );

          if (chapter.sections.length === 0) {
            chapterCompleted = courseProgress
              && courseProgress.completedItems.includes(chapter._id);
          }

          return {
            name: chapter.title,
            id: chapter._id,
            completed: chapterCompleted,
            route: `/learn/courses/${this.course.slug}/${chapter._id}`,
            children: chapter.sections
              .filter((section) => {
                return section.status === 'Published' || this.userRole === 'Administrator';
              })
              .map((section) => {
                const chapterProgress = courseProgress
                  && courseProgress.completedItems.includes(section._id);

                return {
                  id: section._id,
                  name: section.title,
                  completed: chapterProgress,
                  route: `/learn/courses/${this.course.slug}/${chapter._id}/${section._id}`,
                };
              }),
          };
        });
    },
    selectedChapter() {
      if (!this.course) return null;

      return this.course.chapters.find((chapter) => {
        return chapter._id === this.$route.params.chapter_id;
      });
    },
    selectedSection() {
      if (!this.course || !this.selectedChapter) return null;

      return this.selectedChapter.sections.find((s) => {
        return s._id === this.$route.params.section_id;
      });
    },
    navTitle() {
      return this.course && this.course.title
        ? {
          title: this.course.title,
          route: `/learn/courses/${this.course.slug}`,
        } : null;
    },
    he() {
      return this.$vuetify.display.height;
    },
    denseItems() {
      return this.$vuetify.display.height < 950 ?  'compact' : 'default';
    },
  },
  methods: {
    async changeProgram(program) {
      await this.$store.dispatch(
        'programs/getSelectedProgram',
        { programSlug: program.slug, populate: true },
      );

      // if the current route contains program_slug param, we need to update it
      if (this.$route.params.program_slug) {
        this.$router.push({
          name: this.$route.name,
          params: {
            ...this.$route.params,
            program_slug: program.slug,
          },
        });
      }

    },
    navigateTo(item) {
      if (item.permission && !this.can(item.permission[0], item.permission[1])) {
        this.$store.dispatch('dialogs/setPremiumDialog', true);
        return;
      }

      const route = item.route;
      if (this.$router.currentRoute.name === route) {
        return;
      }
      this.$router.push(route);

      if (this.breakpointMobile) {
        this.drawer = false;
      }
    },
  },
};
</script>
<style scoped>

.list-item-selected {
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
}

.v-list-item--density-default .menu-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.2;
}

.v-list-item--density-default .course-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
}


.menu-title {
  color: #FFF;
  font-family: Lora,serif;
}

.course-title {
  color: #FFF;
  font-family: Lora,serif;
}

.v-list-group__items .v-list-item {
  padding-inline-start: calc(1px + var(--indent-padding)) !important;
}

.v-list-group__items .course-section {
  padding-inline-start: calc(-20px + var(--indent-padding)) !important;
}

.course-section :deep(.v-list-item__spacer) {
  width: 20px !important;
}
.course-chapter :deep(.v-list-item__spacer) {
  width: 20px !important;
}

</style>
